/**
 *功能: 登录
 */
export default {
	$getway: 'sysapi',
  getEncryptInfo: 'login/getEncryptInfo',
  login: 'login/login_erp',
  chgPassword: 'operator/chgPassword',
  logout: '/login/logout',
};
